import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

import 'react-select/dist/react-select.css';

import { Label, Input, FormFeedback } from 'reactstrap';
import { validationInputProps } from "../../../utils/inputValidation";

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        buttonClass: PropTypes.string
    }

    render() {
        return (
            <ParadigmaModal
                postUrl={api.clientes.responsables.create}
                successMessage={"El Contacto ha sido creado con éxito."}
                title={"Nuevo Contacto"}
                buttonIcon={"fa fa-plus fa-lg"}
                onSubmit={(callback) => this.props.onSubmit(callback)}
                buttonTitle={"Nuevo Contacto"}
                saveButton={true}
                buttonClass={this.props.buttonClass}
                closeButton={true}
                className={"ui-modal-dialog ui-modal-md"}>
                <div className="ui-form">
                    <div className="ui-section-grid">
                        <section className="ui-section-block ui-section-span-2">
                            <p className="ui-section-label">Identificación</p>
                            <div className="ui-row-2">
                                <div className="ui-field">
                                    <Label>Nombre</Label>
                                    <Input type="text" name="nombre" autoFocus data-auto-focus="true"></Input>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                                <div className="ui-field">
                                    <Label>Apellido</Label>
                                    <Input type="text" name="apellido"></Input>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Empresa</Label>
                                    <ParadigmaAsyncSeeker fieldName={"empresa_id"} url={api.clientes.empresas.select} />
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                        </section>

                        <section className="ui-section-block">
                            <p className="ui-section-label">Datos de contacto</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Tipo</Label>
                                    <ParadigmaAsyncSeeker fieldName={"tipo_id"} multiselect={true} url={api.clientes.tiporesponsables.select} />
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                            <div className="ui-row-2">
                                <div className="ui-field">
                                    <Label>Teléfono</Label>
                                    <Input type="text" name="telefono" ></Input>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                                <div className="ui-field">
                                    <Label>Email</Label>
                                    <Input type="text" name="email"></Input>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                        </section>

                        <section className="ui-section-block">
                            <p className="ui-section-label">Observaciones</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Observaciones</Label>
                                    <Input type="textarea" name="observaciones" rows="5"/>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/clientes/Responsables/Create.js